import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';

import { OPEN_DIALOG, CLOSE_CURRENT_DIALOG, SET_IS_DIALOG_ACTIVE, OPENING_DIALOG, CLOSE_ALL_DIALOGS } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

const TIME_TO_WAIT_BEFORE_ALLOWING_OPENING_ANOTHER_DIALOG = 200;

// actions declarations
export const openDialog = buildActionObject('openDialog');
export const closeCurrentDialog = buildActionObject('closeCurrentDialog');
export const setIsDialogActive = buildActionObject('setIsDialogActive');
export const closeAllDialogs = buildActionObject('closeAllDialogs');

const actions = {
	...StoreModuleService.createDefaultActions(),
	// dialogs are pushed to the array in LIFO order
	[openDialog.action]({ commit }, payload) {
		if (state.openingDialog) {
			return;
		}
		commit(OPENING_DIALOG, true);
		setTimeout(() => {
			commit(OPENING_DIALOG, false);
		}, TIME_TO_WAIT_BEFORE_ALLOWING_OPENING_ANOTHER_DIALOG);
		commit(OPEN_DIALOG, payload);
	},
	[closeCurrentDialog.action]({ commit }, payload) {
		commit(CLOSE_CURRENT_DIALOG, payload);
	},
	[setIsDialogActive.action]({ commit }, payload) {
		const { value } = payload;
		commit(SET_IS_DIALOG_ACTIVE, value);
	},
	async [closeAllDialogs.action]({ commit }) {
		commit(CLOSE_ALL_DIALOGS);
	},
};

export default actions;
